import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';

export interface OrganizationState extends CallStateMethods {
  callState: CallStateEnum;
  token: string | null;
  getApiKey: () => void;
}

interface OrganizationStateMethods extends CallStateMethodNames {
  getApiKey: 'getApiKey';
}

export const ORGANIZATION_INITIAL_STATE: Omit<
  OrganizationState,
  keyof OrganizationStateMethods
> = {
  callState: CallStateEnum.Init,
  token: null
};
